import axios from 'axios'

export const AdminAdoptionProfileService = {
/** if status value is not set --- Published and Inactive
 * if status = 1 -- Inactive
 * if status = 2 -- Published
 */
  fetchAdoptionProfileList (status) {
    return axios.get(`/api/v1/adopprofilelist/${status}`)
  },
  /**
   * edit code year record
   */
  editAdoptionProfileItem (data) {
    return axios.post(`/api/v1/editadopprofile`, JSON.stringify({
      name: data.name,
      status: data.status,
      userId: data.userId,
      id: data.id
    }))
  },
  /**
   * Add new code year record
   */
  addAdoptionProfileItem (data) {
    return axios.post(`/api/v1/addadopprofile`, JSON.stringify({
      name: data.name,
      status: data.status,
      userId: data.userId
    }))
  }
}
